export const PAGE_LIMIT = 50;
export const DEBOUNCE_TIME_MS = 700;
